import { graphql } from './graphql/generated';

export const ASSIGNMENT_FOR_CURRENT_USER_QUERY = graphql(`
  query AssignmentForCurrentUser {
    assignmentForCurrentUser {
      id
      primaryDoctor {
        id
      }
    }
  }
`);

export const USER_DOCTOR_AUTH_CHECK_QUERY = graphql(`
  query UserDoctorAuthCheckQuery($doctorId: ID!) {
    isCurrentUserAuthorizedForDoctor(doctorId: $doctorId)
  }
`);
